var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_13104)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32_13104)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_13104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7168 0.539062H0.716797V16.5391H16.7168V0.539062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_13104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 4.53873C10.7345 4.66578 11.333 4.98424 11.8021 5.45336C12.2712 5.92248 12.5897 6.52091 12.7167 7.17207M10.0834 1.87207C11.4362 2.02236 12.6978 2.62818 13.6609 3.59007C14.624 4.55196 15.2314 5.81274 15.3834 7.1654M7.53472 9.78078C6.73367 8.97973 6.10114 8.07397 5.63714 7.10755C5.59723 7.02443 5.57728 6.98286 5.56195 6.93027C5.50746 6.74337 5.5466 6.51386 5.65994 6.35558C5.69183 6.31103 5.72994 6.27293 5.80615 6.19672C6.03922 5.96365 6.15575 5.84712 6.23194 5.72993C6.51927 5.288 6.51927 4.71828 6.23194 4.27636C6.15575 4.15917 6.03922 4.04264 5.80615 3.80956L5.67623 3.67965C5.32194 3.32536 5.14479 3.14821 4.95454 3.05198C4.57616 2.8606 4.12932 2.8606 3.75094 3.05198C3.56069 3.14821 3.38354 3.32536 3.02925 3.67965L2.92416 3.78474C2.57108 4.13782 2.39454 4.31436 2.2597 4.55439C2.11009 4.82072 2.00252 5.23438 2.00342 5.53987C2.00424 5.81516 2.05765 6.00331 2.16445 6.37961C2.73843 8.40187 3.82141 10.3101 5.4134 11.9021C7.00539 13.4941 8.91363 14.5771 10.9359 15.1511C11.3122 15.2579 11.5003 15.3113 11.7756 15.3121C12.0811 15.313 12.4948 15.2055 12.7611 15.0558C13.0011 14.921 13.1777 14.7445 13.5307 14.3914L13.6358 14.2863C13.9901 13.932 14.1673 13.7549 14.2635 13.5646C14.4549 13.1862 14.4549 12.7394 14.2635 12.361C14.1673 12.1708 13.9901 11.9936 13.6358 11.6393L13.5059 11.5094C13.2728 11.2763 13.1563 11.1598 13.0391 11.0836C12.5972 10.7963 12.0275 10.7963 11.5856 11.0836C11.4684 11.1598 11.3518 11.2763 11.1188 11.5094C11.0426 11.5856 11.0044 11.6237 10.9599 11.6556C10.8016 11.7689 10.5721 11.8081 10.3852 11.7536C10.3326 11.7383 10.2911 11.7183 10.208 11.6784C9.24153 11.2144 8.33577 10.5819 7.53472 9.78078Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_13104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.716797 0.539062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32_13104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.716797 0.539062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.88872af4c0d0c4c7452310443f224e92.svg";
export { ForwardRef as ReactComponent };